import { createFileRoute } from "@tanstack/react-router";
import { createColumnHelper } from "@tanstack/react-table";

import { useFilters } from "../../../hooks/useFilters";
import { flightsResourcePath } from "../../../services/queries/flights";
import { useGetFlights } from "../../../services/queries/flights";
import Pagination from "../../../components/Pagination";
import Table from "../../../components/Table";
import { Flight } from "../../../services/queries/flights/types";
import { useAppState } from "../../../contexts/AppContext";
import { requireRouteAccess } from "../../../utils/authorization";

const columnHelper = createColumnHelper<Flight>();

const columns = [
  columnHelper.accessor("flightNumber", {
    cell: (info) => info.getValue(),
    header: "Flight No.",
  }),
  columnHelper.accessor((info) => `${info.firstName} ${info.lastName}`, {
    cell: () => "",
    header: "Passenger",
  }),
  columnHelper.accessor(
    (info) => `${info.originCity} (${info.originAirportCode})`,
    {
      cell: () => "",
      header: "From",
    },
  ),
  columnHelper.accessor(
    (info) => `${info.destinationCity} (${info.destinationAirportCode})`,
    {
      cell: () => "",
      header: "To",
    },
  ),
  columnHelper.accessor(
    (info) => `${info.departureDate} ${info.departureTime}`,
    {
      cell: () => "",
      header: "Departs",
    },
  ),
  columnHelper.accessor((info) => `${info.arrivalDate} ${info.arrivalTime}`, {
    cell: () => "",
    header: "Arrives",
  }),
  columnHelper.accessor("stops", {
    cell: () => "",
    header: "Stops",
  }),
];

export const Route = createFileRoute("/_app/flights/")({
  beforeLoad: () => requireRouteAccess("/flights"),
  component: Flights,
});

function Flights() {
  const {
    filters: { pageSize, pageNumber },
    buildApiUrl,
    setFilters,
  } = useFilters();

  const {
    state: { business },
  } = useAppState();

  const businessId = business?.id || "";

  const handlePageChange = (selectedItem: { selected: number }) => {
    setFilters({ pageNumber: selectedItem.selected + 1 });
  };

  const url = buildApiUrl(flightsResourcePath);
  const { isLoading, data: flightsData } = useGetFlights(businessId, url);

  const flights = flightsData?.data?.list || [];
  const totalRecords = flightsData?.data?.meta?.total || 0;
  const pageCount = Math.ceil(totalRecords / Number(pageSize));

  return (
    <div className="transactions-page">
      <div className="bg-white overflow-x-auto relative p-6">
        <Table
          loading={isLoading}
          data={flights}
          columns={columns}
          rowClassName="uppercase"
        />

        <Pagination
          pageCount={pageCount}
          currentPage={pageNumber}
          onPageChange={handlePageChange}
        />
      </div>
    </div>
  );
}
